import { useMemo } from 'react'

import { ProjectFragment, ShareListItemFragment } from '@sketch/gql-types'
import { pluralize } from '@sketch/utils'

type StorageItem =
  | Pick<ShareListItemFragment, 'identifier' | '__typename'>
  | Pick<ProjectFragment, 'identifier' | '__typename'>

export const useStorageItemsCount = (items: StorageItem[]) => {
  return useMemo(() => {
    const { projects, shares } = items.reduce(
      (acc, item) => {
        if (item.__typename === 'Project') {
          acc.projects += 1
        } else if (item.__typename === 'Share') {
          acc.shares += 1
        }

        return acc
      },
      { projects: 0, shares: 0 }
    )

    const message = []

    if (shares > 0) {
      message.push(`${shares} ${pluralize('Document', 'Documents', shares)}`)
    }
    if (projects > 0) {
      message.push(`${projects} ${pluralize('Project', 'Projects', projects)}`)
    }

    const joinedMessage = message.join(' and ')
    return { message: joinedMessage, shares, projects }
  }, [items])
}
